enum HealthStatus {
  Unknown = 'unknown',
  Online = 'online',
  Offline = 'offline',
}

export default HealthStatus;
